export default {
  state: {
    data: null,
    api: null,
    breadcrumb: [''],
  },
  getters: {
    dataError(state) {
      if (state.data) {
        const breadcrumbPath = state.breadcrumb.filter(d => d != location.hash.replace(/#/, ''))
        let breadcrumb = breadcrumbPath.length
          ? breadcrumbPath.splice(breadcrumbPath.length - 2, 2)[0]
          : '/'

        return {
          message: state.data.message,
          url: state.data.config.baseURL + state.data.config.url,
          breadcrumb: breadcrumb,
        }
      }
    },
    apiError(state) {
      if (state.api) {
        const breadcrumbPath = state.breadcrumb.filter(d => d != location.hash.replace(/#/, ''))
        let breadcrumb = breadcrumbPath.length
          ? breadcrumbPath.splice(breadcrumbPath.length - 2, 2)[0]
          : '/'

        return {
          message: state.api.message,
          url: state.api.config.baseURL + state.api.config.url,
          breadcrumb: breadcrumb,
        }
      }
    },
  },
  mutations: {
    dataError(state, error) {
      state.data = error
    },
    apiError(state, error) {
      state.api = error
    },
    errorBreadcrumb(state, url) {
      state.breadcrumb.push(url)
      state.data = null
      state.api = null
    },
  },
  actions: {},
}
